import React, { createContext, useContext, useState, useCallback } from 'react';

const SearchCriteriaContext = createContext(null);

export const SearchCriteriaProvider = ({ children }) => {
  const [criteria, setCriteria] = useState({
    hotels: null,
    excursions: null,
    carRental: null
  });

  const updateCriteria = useCallback((serviceType, searchData) => {
    setCriteria(prev => ({
      ...prev,
      [serviceType]: searchData
    }));
  }, []);

  const clearCriteria = useCallback((serviceType) => {
    setCriteria(prev => ({
      ...prev,
      [serviceType]: null
    }));
  }, []);

  const value = {
    criteria,
    updateCriteria,
    clearCriteria
  };

  return (
    <SearchCriteriaContext.Provider value={value}>
      {children}
    </SearchCriteriaContext.Provider>
  );
};

export const useSearchCriteria = () => {
  const context = useContext(SearchCriteriaContext);
  if (!context) {
    throw new Error('useSearchCriteria must be used within SearchCriteriaProvider');
  }
  return context;
};
